export const blockIconsAudioandvideoRepeatNew = (
	<span className='material-symbols-outlined'>repeat</span>
);
